import type { FlowCardDefinition } from '../types';

function manualCard(webhook: boolean): FlowCardDefinition {
	const paletteKey = webhook ? 'webhookTrigger' : undefined;
	return {
		type: 'manualCondition',
		...(paletteKey ? { paletteKey } : {}),
		version: '1.0.0',
		domain: 'core',
		role: 'condition',
		category: 'conditions',
		label: webhook ? 'Webhook Trigger' : 'Manual Trigger',
		description: webhook
			? 'Start this flow when its webhook endpoint is called'
			: 'Start this flow when the user runs it manually',
		icon: webhook ? 'fa-link' : 'fa-hand-pointer',
		color: '#8b5cf6',
		schema: {
			$schema: 'https://json-schema.org/draft/2020-12/schema',
			type: 'object',
			properties: { triggerMode: { type: 'string', enum: [webhook ? 'webhook' : 'manual'] } },
		},
		fields: [
			{
				path: '',
				label: '',
				type: 'info',
				content: webhook
					? 'The flow starts when its webhook endpoint is called. Use this as the only starting condition.'
					: 'The flow starts when you run it manually. Use this as the only starting condition.',
			},
		],
		ports: { sources: ['true'] },
		defaults: () => ({ triggerMode: webhook ? 'webhook' : 'manual', cardVersion: '1.0.0' }),
		summary: () => (webhook ? 'Run when the webhook is called' : 'Run when started manually'),
		compile: (node) => ({
			_gui_type: 'manual_execution',
			_gui_purpose: 'condition',
			_fid: node.id,
			_flow_card: webhook ? 'webhookTrigger' : 'manualCondition',
			_flow_card_version: '1.0.0',
		}),
	};
}

export const manualConditionCards = [manualCard(false), manualCard(true)];
